module.exports = __webpack_public_path__ + "img/HarmonyCityLogo.c9719163.png";